import { useQuery } from "@tanstack/react-query";

import { getFarmDataSubmissionStatus, getFarmDataSubmissionStatusAdmin } from "services";

import { GET_FARM_DATA_SUBMISSION_STATUS } from "consts";

export const useGetFarmDataSubmissionStatus = ({ farmId, isAdmin }: { farmId: string; isAdmin?: boolean }) =>
  useQuery({
    queryKey: [GET_FARM_DATA_SUBMISSION_STATUS, farmId, isAdmin],
    queryFn: ({ signal }) => (isAdmin ? getFarmDataSubmissionStatusAdmin({ farmId, signal }) : getFarmDataSubmissionStatus({ farmId, signal })),
    enabled: !!farmId,
  });
